import React from "react";

class TextField extends React.Component{
    render(){
        const that = this
        return (
            <div class="js-form-field__wrapper">
                <div class="js-form-field__text">
                    <input 
                        type="text" 
                        name={this.props.name}
                        id={this.props.id}
                        
                        // defaultValue={this.props.value}
                        placeholder={this.props.placeholder}
                        required={this.props.required}
                        />
                </div>
            </div>
        )
    }
}

export default TextField